// extracted by mini-css-extract-plugin
export default {"container":"List-module--container--4vq4s","item":"List-module--item--P+J1U","card":"List-module--card--mytx9","icon":"List-module--icon--hIKHh","text":"List-module--text--Pvvcw"};